<template>
  <div>
    <common-list ref="list" url="Role/GetList" @currentrow="handlerCurrentRow">
      <template v-slot:filter="{ filter }">
      <el-col :span="8">
        <el-form-item label="角色名" prop="RoleName">
          <el-input
            v-model.trim="filter.RoleName"
            placeholder="角色名"
            clearable
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="所属机构"  prop="OrgId">
          <StationSelect
            v-model="filter.OrgId"
            :isShow="true"
          ></StationSelect>
        </el-form-item>
      </el-col>
      </template>
    
      <template v-slot:option>
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="add"
          v-if="auth('RoleAdd')"
          >添加</el-button
        >

        <el-button
          type="warning"
          icon="el-icon-edit"
          @click="edit"
          v-if="auth('RoleEdit')"
          >编辑</el-button
        >
        <el-button
          type="danger"
          icon="el-icon-delete"
          @click="deleteItem"
          v-if="auth('RoleDelete')"
          >删除</el-button
        >
        <el-button type="primary" @click="rolePower" v-if="auth('RolePower')"
          >授权</el-button
        >
      </template>
      <template v-slot:body>
        <el-table-column
          label="角色名"
          prop="RoleName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="角色描述"
          prop="Remark"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="所属机构"
          prop="CompanyName"
          show-overflow-tooltip
        ></el-table-column>
      </template>
    </common-list>
    <add-edit
      ref="addedit"
      @success="getData"
      :item="aeitem"
      title="角色"
      getUrl="Role/GetItemByID"
      addUrl="Role/Add"
      editUrl="Role/Edit"
      width="500px"
    >
      <template v-slot="{ form }">
        <el-form-item label="所属机构">
          <StationSelect
            v-model="form.OrgId"
            :isShow="true"
          ></StationSelect>
        </el-form-item>
        <el-form-item
          label="角色名"
          prop="RoleName"
          :rules="[$g.validRequired, $g.validLen(20)]"
        >
          <el-input
            v-model.trim="form.RoleName"
            placeholder="角色名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="角色描述" prop="Remark" :rules="$g.validLen(30)">
          <el-input
            v-model.trim="form.Remark"
            placeholder="角色描述"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="角色授权">
          <PowerTree v-model="form.RolePowerID"></PowerTree>
        </el-form-item>
      </template>
    </add-edit>
    <role-power :item="authitem"></role-power>
  </div>
</template>

<script>
import RolePower from "./RolePower.vue";
import PowerTree from "./PowerTree.vue";
export default {
  components: { RolePower, PowerTree },
  data() {
    return {
      aeitem: {},
      authitem: {},
    };
  },
  mounted() {},
  methods: {
    getData() {
      this.$refs.list.getTableData();
    },
    add() {
      this.$refs.addedit.type = "add";
      this.aeitem = {};
    },
    edit() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$refs.addedit.type = "edit";
      this.aeitem = { RoleId: this.currentrow.RoleId };
    },
    deleteItem() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$confirm(
        `将删除名称为【${this.currentrow.RoleName}】的角色名, 是否继续?`,
        "提示信息",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "el-button--canale",
          type: "warning",
        }
      )
        .then(() => {
          this.$delete("Role/Delete", {
            RoleId: this.currentrow.RoleId,
          }).then(() => {
            this.$refs.list.getTableData();
          });
        })
        .catch(() => {});
    },
    rolePower() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.authitem = {
        RoleId: this.currentrow.RoleId,
        RoleName: this.currentrow.RoleName,
      };
    },
  },
};
</script>

<style>
</style>